import { _ as t } from "../internals/export.js";
t({
  target: "Date",
  proto: !0
}, {
  toGMTString: Date.prototype.toUTCString
});